<main>
  <div class="home ver2">
    <div class="app-home">
      <div class="row hero">
        <a href="#" class="home-logo">
          <img src= "{{configurationService.assetsPath}}/assets/img/logos/rankipedia-logo.png" alt="Logo"/>
        </a>
        <h2>Find what you want <span class="bold">without the marketing</span></h2>
        <p>
          HOME2: Artificially Intelligent Ranking-Matching Engine
        </p>
      </div>
      <ranki-app-search [minimode]="true"></ranki-app-search>
      <ranki-app-narrative-text [textkey]="'HomepageDescription'"></ranki-app-narrative-text>
      <div class="row help-videos">
        <div class="col">
          <video poster="/Content/images/home-video-professionals.png" controls="">
            <source src="/MultimediaShare/video/Rankipedia2.mp4" type="video/mp4">
          </video>
          <a href="/for-professionals" class="btn tertiary">Learn More</a>
        </div>
        <div class="col">
          <video poster="/Content/images/home-video-consumers.png" controls="">
            <source src="/MultimediaShare/video/Rankepedia3.mp4" type="video/mp4">
          </video>
          <a href="/for-consumers" class="btn tertiary">Learn More</a>
        </div>
      </div>      
    </div>
  </div>
</main>
